export const CUSTOMTEXTS_FETCH_REQUESTED = 'CUSTOMTEXTS_FETCH_REQUESTED'
export const CUSTOMTEXTS_FETCH_SUCCESS = 'CUSTOMTEXTS_FETCH_SUCCESS'
export const CUSTOMTEXTS_FETCH_FAILED = 'CUSTOMTEXTS_FETCH_FAILED'
